const ns = 'APP__';

export const SET_ACTIVE_COMPANY = `${ns}SET_ACTIVE_COMPANY`;
export const SET_ACTIVE_APP = `${ns}SET_ACTIVE_APP`;
export const DATA_LOADED = `${ns}DATA_LOADED`;
